<template>
  <section class="generation-section">
    <div class="generation-bg" id="generationBg">
      <div
        class="generation-line generation-line__1"></div>
      <div
        class="generation-line generation-line__2"></div>
      <div
        class="generation-line generation-line__1"></div>
<!--      <div-->
<!--        class="generation-line generation-line__2"></div>-->
    </div>
    <div class="container">
      <img
        :src="require('@/assets/image/generation-section/station.png')"
        alt="station"
        class="station">
      <div class="about">
        <div class="about__heading">
          <span>№7</span> Первые в 5G
        </div>
        <div class="about__text">
          МТС первой в России получила лицензию на
          создание сети 5G. Это позволит серфингу
          в интернете выйти на новый уровень скорости и комфорта
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { gsap, TweenMax } from 'gsap';

export default {
  name: 'v-generation-section',
  mounted() {
    const timelineGeneration = gsap.timeline({
      scrollTrigger: {
        trigger: '.generation-section',
        start: '-=50%',
        end: 'bottom',
        scrub: 1,
        onUpdate: (self) => {
          console.log('progress5:', self.progress);
          const generationBg = document.getElementById('generationBg');
          if (self.progress > 0.8 && !generationBg.classList.contains('activate')) {
            generationBg.classList.add('activate');
            TweenMax.to('.generation-bg', {
              opacity: 0,
            });
          }
          if (self.progress < 0.8 && generationBg.classList.contains('activate')) {
            generationBg.classList.remove('activate');
            TweenMax.to('.generation-bg', {
              opacity: 1,
            });
          }
        },
      },
    });
    const timelineGeneration2 = gsap.timeline({
      scrollTrigger: {
        trigger: '.generation-section',
        start: '-=50%',
        end: 'bottom',
        scrub: 1,
      },
    });
    timelineGeneration.addLabel('start')
      .to('.generation-line__1', {
        duration: 1,
        backgroundPositionX: '100%',
      });
    timelineGeneration2.addLabel('start')
      .to('.generation-line__2', {
        duration: 1,
        backgroundPositionX: 0,
      });
  },
};
</script>

<style lang="scss">
.generation-section {
  position: relative;
  min-height: unset;
  margin-bottom: -20px;

  .container{
    position: relative;
    min-height: unset;
    background: linear-gradient(180deg, rgba(244, 244, 244, 0) 45%, #F4F4F4 50%);
    z-index: 20;
  }
  .generation-bg{
    position: sticky;
    top: 0;
    max-width: 100%;
    height: 100px;
  }

  .about{
    padding-top: 40px;
    background: linear-gradient(180deg, rgba(244, 244, 244, 0) 10%, #F4F4F4 35%);
  }
}
.generation-line{
  height: 150px;
  background-image: url('../assets/image/generation-section/5g.png');
  background-size: auto 100%;
  margin-bottom: 10px;
  background-repeat: no-repeat;

  &__1{
    background-position: 0 center;
  }
  &__2{
    background-position: 100% center;
  }
}
.station{
  display: block;
  margin: 0 auto;
  width: 130px;
}
</style>
